import { fetchAccountData, getLogonProfile, patchChangeTripActions } from '@amtrav/webservice';
import { getAndProcessAutomatedActions } from '../apps/change-trip/services/automatedActionsProcessor';

const getLogonProfileHandler = () => {
  return getLogonProfile()
    .then((result) => result)
    .catch((err) => {
      console.warn('Unauthorized or corrupted user session. Redirecting to logout page.', err.code);
      console.error(err);
      const errorCodesRequiringLogout = [7008, 7048, 8005];
      if (errorCodesRequiringLogout.includes(err.code)) {
        window.location.href = '/logout';
      }
    });
};

// TODO add defaults to reduce redundancy
export const storeIdentifiers = {
  changeTrip: { name: 'changeTrip', keyPath: 'key', type: 'local' },
  user: { name: 'user', keyPath: 'key', type: 'session' },
};

// const ONE_HOUR = 3_600_000;
// const FIFTEEN_MINUTES = 900_000;
const FIVE_MINUTES = 300_000;
const NO_CACHE = 0;

export const serviceConfigs = {
  changeTripAutomatedActions: {
    key: 'changeTripAutomatedActions',
    ttl: NO_CACHE,
    storeConfig: storeIdentifiers.changeTrip,
    serviceCall: getAndProcessAutomatedActions,
  },
  patchChangeTripActions: {
    key: 'patchChangeTripActions',
    ttl: NO_CACHE,
    storeConfig: storeIdentifiers.changeTrip,
    serviceCall: patchChangeTripActions,
  },
  accountData: {
    key: 'accountData',
    ttl: FIVE_MINUTES,
    storeConfig: storeIdentifiers.user,
    serviceCall: fetchAccountData,
    clearOnRefresh: true,
  },
  logonProfile: {
    key: 'logonProfile',
    ttl: FIVE_MINUTES,
    storeConfig: storeIdentifiers.user,
    serviceCall: getLogonProfileHandler,
    clearOnRefresh: true,
  },
};
